<template>
    <div class="tags">
        <span class="b2" v-for="(its, idx) in tagsArr" :key="idx" :class="{'b1': its === 0}">
            <img :src="require('../../../assets/img/b2b/b'+ parseInt(its+1) +'.png')" alt="" class="icon">
        </span>
    </div>
</template>

<script>
export default {
    name: 'tags',
    props: {
        tagsArr: {
            type: Array
        }
    }
}
</script>

<style lang="scss" scoped>
    .tags {
        display: inline-flex;
        overflow: hidden;
        margin-right: 4px;
        vertical-align: bottom;
        span {
            margin-right: 8px;
            &.b2 {
                width: 56px;
            }
            &.b1 {
                width: 40px;
            }
            .icon {
                height: 32px;
                margin-top: 2px;
            }
        }
    }
</style>